/**
 * SyM Asociados - Performance Mobile
 * Ataca INP (454ms) y LCP (3.6s) en móvil:
 * 1. Desactiva scroll-synergy parallax/zoom en móvil
 * 2. Difiere listeners de scroll hasta primera interacción
 * 3. Marca elementos off-screen para content-visibility
 */
(function() {
  'use strict';

  var isMobile = window.matchMedia('(max-width: 749px)').matches;

  // --- INP: desactivar parallax/zoom en móvil ---
  if (isMobile) {
    document.addEventListener('DOMContentLoaded', function() {
      var els = document.querySelectorAll('.behavior--parallax.scroll-synergy, .behavior--zoom-in.scroll-synergy');
      els.forEach(function(el) {
        el.classList.remove('scroll-synergy');
        el.style.transform = 'none';
        el.style.willChange = 'auto';
      });
    }, { once: true });
  }

  // --- INP: diferir initScrollSynergy hasta primera interacción ---
  var scrollInitialized = false;
  function deferScrollInit() {
    if (scrollInitialized) return;
    scrollInitialized = true;
    if (!isMobile && typeof webvista !== 'undefined' && webvista.initScrollSynergy) {
      if (window.requestIdleCallback) {
        requestIdleCallback(function() { webvista.initScrollSynergy(); }, { timeout: 2000 });
      } else {
        setTimeout(function() { webvista.initScrollSynergy(); }, 500);
      }
    }
  }
  window.addEventListener('scroll', deferScrollInit, { once: true, passive: true });
  window.addEventListener('pointerdown', deferScrollInit, { once: true, passive: true });

  // --- INP: aplicar content-visibility a secciones off-screen ---
  if ('IntersectionObserver' in window && isMobile) {
    document.addEventListener('DOMContentLoaded', function() {
      var sections = document.querySelectorAll('section.shopify-section:not(:first-child)');
      sections.forEach(function(section) {
        section.style.contentVisibility = 'auto';
        section.style.containIntrinsicSize = '0 400px';
      });
    }, { once: true });
  }

})();
